import { useEffect, useState } from "react";

const useTheme = ({ theme }) => {
  const [darkMode, setDarkMode] = useState(theme ?? false);

  useEffect(() => {
    sessionStorage.setItem("theme", JSON.stringify(darkMode));

    const body = document.querySelector("body");

    if (darkMode) {
      body.classList.add("dark-map");
    } else {
      body.classList.remove("dark-map");
    }
  }, [darkMode]);

  return { darkMode, setDarkMode };
};

export default useTheme;
